import * as React from 'react'
import { TableRow } from 'components/Table'
import { VirtuosoContext } from '../VirtualTableInfiniteScrollLoader'

interface VirtualStripedTableRowProps
  extends React.HTMLAttributes<HTMLTableRowElement> {
  children?: React.ReactNode
  'data-index': number
  context?: VirtuosoContext<any>
}

/**
 * Virtual Striped Table Row
 * Uses the index as specified by the Virtuoso component to conditionally render
 * the row props.
 */
export default React.forwardRef<
  HTMLTableRowElement,
  VirtualStripedTableRowProps
>(function VirtualStripedTableRow(props, ref) {
  const { context } = props

  const item = context?.scroller.items[props['data-index']]
  const onClickItemRow =
    context?.onClickItemRow && item
      ? () => context.onClickItemRow!(item)
      : undefined

  return (
    <TableRow
      ref={ref}
      odd={props['data-index'] % 2 !== 0}
      onClick={onClickItemRow}
      {...props}
    />
  )
})
